<template>
  <div class="IMC_box">
    <div class="IMC_box_title">
      <div class="IMC_box_title_left">
        <span>{{ $t('imc_title') }}</span>
        <div class="mgx_action_btn" @click="emit('open-video')">
          <div class="icon-wrapper">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 12L10 15V9L15 12Z" fill="currentColor" />
              <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" stroke-width="2.5" />
            </svg>
          </div>
          {{ $t('video_msg') }}
        </div>
      </div>
      <div class="mgx_action_btn" @click="showHelp = true">
        <div class="icon-wrapper">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.24" />
            <path
              d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.9175 10C14.9175 12 11.9175 13 11.9175 13"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M12 17H12.01" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        {{ $t('imc_help_msg') }}
      </div>
    </div>
    <div class="IMC_box_desc1">
      {{ $t('imc_mode_desc') }}
    </div>
    <div class="IMC_box_desc">{{ $t('imc_mode_desc1') }}</div>
    <div class="IMC_box_desc">{{ $t('imc_mode_desc2') }}</div>
    <div class="IMC_box_desc">{{ $t('imc_mode_desc3') }}</div>
    <div class="mgx_mode_desc">按FN+右ALT+I即可在经典输入模式和IMC模式之间切换</div>
  </div>
  <Teleport to="body">
    <IMCHelpDialog v-if="showHelp" @close="showHelp = false" />
  </Teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IMCHelpDialog from './IMC_help_dialog.vue'

const emit = defineEmits(['open-video'])
const showHelp = ref(false)
</script>

<style lang="less" scoped>
.IMC_box {
  position: relative;
  padding: 24px;
  background: var(--bg-card);
  border-radius: var(--radius-l);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: visible;
  transition: var(--transition-base);

  .IMC_box_title {
    font-size: 20px;
    color: var(--color-dark);
    font-weight: 800;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .IMC_box_title_left {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    .mgx_action_btn {
      height: 32px;
      padding: 0 16px;
      font-size: 13px;
      background: rgba(255, 255, 255, 0.6);
      color: var(--brand-color-pure);
      border-color: rgba(0, 0, 0, 0.05);

      &:hover {
        background: var(--brand-color);
        color: var(--color-white);
        border-color: transparent;
        box-shadow: 0 4px 12px rgba(var(--color-brand-2-rgb), 0.3);
      }
    }
  }

  .IMC_box_desc1 {
    color: var(--color-dark);
    font-size: 14px;
    line-height: 1.5;
    padding: 12px 16px;
    background: rgba(var(--color-brand-2-rgb), 0.03);
    border-radius: var(--radius-m);
    border-left: 4px solid var(--brand-color-pure);
  }

  .IMC_box_desc {
    position: relative;
    padding-left: 20px;
    margin-top: 10px;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.5;
    display: flex;
    align-items: flex-start;

    &::before {
      content: '*';
      position: absolute;
      left: 0;
      color: var(--brand-color-pure);
      font-size: 18px;
      line-height: 1.2;
    }
  }

  .mgx_mode_desc {
    margin-top: 12px;
    padding: 10px 16px;
    font-size: 13px;
    color: var(--text-secondary);
    background: rgba(0, 0, 0, 0.03);
    border-radius: var(--radius-s);
    display: inline-block;
    width: fit-content;
    font-weight: 500;
  }
}

@media (max-width: 900px) {
  .IMC_box {
    .IMC_box_title {
      flex-direction: column;
      align-items: flex-start;

      .IMC_box_title_left {
        width: 100%;
        flex-wrap: wrap;
      }
    }
  }
}
</style>
